module.exports = __webpack_public_path__ + "img/logo.93aff756.png";